// @module Katoomi.Ship
define('Katoomi.Shiphawk.CartItemsShip.View'
    , [
        'katoomi_shiphawk_cartitemsship.tpl'
        , 'Wizard.Module'
        , 'Backbone.CompositeView'
        , 'Backbone.CollectionView'
        , 'Address.Details.View'
        , 'Utils'
        , 'LiveOrder.Model'
        , 'Transaction.Line.Views.Cell.Navigable.View'
        , 'underscore'
    ]
    , function (
        katoomi_shiphawk_cartitemship_tpl
        , WizardModule
        , BackboneCompositeView
        , BackboneCollectionView
        , AddressDetailsView
        , Utils
        , LiveOrderModel
        , TransactionLineViewsCellNavigableView
        , _
    ) {
        'use strict';
        return WizardModule.extend({
            template: katoomi_shiphawk_cartitemship_tpl,
            // @method initialize Attach to any change on the model and make a render on this changes
            // @return {Void}
            initialize: function () {
                var self = this;
                WizardModule.prototype.initialize.apply(this, arguments);
                this.wizard.model.on('ismultishiptoUpdated', function () {
                    self.render();
                });
                this.wizard.model.on('promocodeUpdated', function () {
                    self.render();
                });
                this.wizard.model.on('change:lines', function () {
                    self.lines = self.wizard.model.getShippableLines();
                    self.render();
                });
                this.lines = this.wizard.model.getShippableLines();
                BackboneCompositeView.add(this);
                this.options = this.options || {};
                this.options.exclude_on_skip_step = true;
                this.wizard.model.on('change:shipaddress', function() { self.initializeAddress() });
                this.initializeAddress(true);
            },
            initializeAddress: function (no_render) {
                this.wizard.model.off('change:shipaddress', function() { self.initializeAddress() });
                if (this.address) {
                    this.address.off('change', null, null);
                }
                this.address = this.wizard.options.profile
                    .get('addresses')
                    .get(this.wizard.model.get('shipaddress'));
                if (this.address) {
                    this.address.on('change', this.render, this);
                }
                if (!no_render) {
                    this.render();
                }
            },
            isActive: function isActive() {
                return this.lines.length;
            },
            // @property {Object} childViews
            childViews: {
                'Items.Collection': function () {
                    return new BackboneCollectionView({
                        collection: this.lines,
                        childView: TransactionLineViewsCellNavigableView,
                        viewsPerRow: 1,
                        childViewOptions: {
                            navigable: false,
                            detail1Title: Utils.translate('Qty:'),
                            detail1: 'quantity',
                            detail2Title: Utils.translate('Unit price:'),
                            detail2: 'rate_formatted',
                            detail3Title: Utils.translate('Amount:'),
                            detail3: 'total_formatted'
                        }
                    });
                },
                'Address.Details': function () {
                    if (this.address) {
                        return new AddressDetailsView({
                            model: this.address,
                            hideActions: true,
                            hideDefaults: true,
                            hideSelector: true
                        });
                    }
                }
            },
            render: function() {
                this.application = this.wizard.application;
                this.profile = this.wizard.options.profile;
                this.options.application = this.wizard.application;
        
                if (this.isActive()) {
                    this._render();
                }
            },
            //@method getContext @return Katoomi.Shiphawk.Checkout.View.Context
            //@method getContext @return Katoomi.KatoomiShiphawkConnector.KatoomiShiphawkModule.View.Context
            getContext: function() {
                var lines = this;
                
                var item_count = this.lines.length;
                // @class OrderWizard.Module.CartItems.Context
                return {
                    // @property {LiveOrder.Model} model
                    model: this.wizard.model,
                    // @property {Number} itemCount
                    itemCount: item_count,
                    // @property {Boolean} showOpenedAccordion
                    showOpenedAccordion: this.options.show_opened_accordion,
                    // @property {Boolean} showOpenedAccordion
                    isAccordionPrimary: this.options.is_accordion_primary,
                    // @property {Boolean} showEditCartButton
                    showEditCartButton: this.options.show_edit_cart_button,
                    // @property {Boolean} showHeaders
                    showHeaders: this.options.show_headers,
                    // @property {Boolean} showMobile
                    showMobile: this.options.show_mobile,
                    // @property {Address.Model} address
                    address: this.address,
                    // @property {Boolean} showAddress
                    showAddress:
                        this.address && this.options.hide_address !== true && !this.wizard.isMultiShipTo()
                };
            }
        });
    });
